import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkloadMemberDetailEntity } from '../../../domain/entities/workload-member-detail.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { GetWorkloadMemberDetailQuery } from './get-workload-member-detail.query';

@Injectable({ providedIn: 'root' })
export class GetWorkloadMemberDetailUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(query: GetWorkloadMemberDetailQuery): Observable<WorkloadMemberDetailEntity> {
    return this._repository.getMemberDetail(query.userId, query.closedPage, query.closedSize);
  }
}
